export default __webpack_public_path__ + "static/mistake-5-cd8c69ff91614748e6c2e343e52215c5.png";